/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { makeStyles, Button, withStyles, Tooltip } from "@material-ui/core";
import _ from "lodash";
import { Calendar, DateObject } from "react-multi-date-picker";
import { ReactComponent as EnterIcon } from "resources/enter-icon.svg";
import moment from "moment";
import { FiDelete } from "react-icons/fi";
import DailyPromotionsWeigthChartComponent from "./DailyPromotionsWeigthChartComponent";
import ExplicabilityComponent from "../explicability-info/ExplicabilityComponent";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    fontSize: 22,
    color: "#999999",
  },
  icon: {
    width: "24px",
    height: "24px",
  },
  iconReset: {
    width: "17px",
    height: "17px",
  },
  containerIcons: {
    height: "210px",
    width: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    borderRight: "1px solid #e2e2e2",
    paddingRight: "10px",
  },
  enterIcon: {
    paddingBottom: "3px",
  },
  resetIcon: {
    paddingTop: "6px",
  },
  expansionDetailsContainer: {
    height: "200px",
    width: "950px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "40px",
    marginTop: "20px",
  },
  explicabilityContainer: {
    display: "flex",
    height: "110px",
    width: "30px",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  tooltipContainer: { padding: "5px" },
  customCalendar: {
    border: "none",
    "& .rmdp-week-day": {
      color: "#e86861",
    },
    "& .rmdp-day:not(.rmdp-day-hidden) span:hover": {
      backgroundColor: "#e86861",
    },
    "& .rmdp-day.rmdp-selected span:not(.highlight)": {
      backgroundColor: "#e86861",
      color: "white",
    },
    "& .rmdp-day.rmdp-today span , .rmdp-day": {
      backgroundColor: "transparent",
      color: "#4e4e4e",
    },
  },
  customCalendarInput: {
    background: "#e86861",
  },
}));
const StyledTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: "gray",
  },
}))(Tooltip);

function DailyPromotionsComponent({
  setIsSelectedDays,
  scenarioEstimationsDaily,
  setDailySelectedEstimations,
  setDailyTotalWeight,
  setCalendarDays,
  setIsSelectedSameDays,
  deltaEventsCatalog,
}) {
  const classes = useStyles();
  const scenariosSlice = useSelector((state) => state.scenarios);
  const [values, setValues] = useState([]);
  const [totalWeightsByDate, setTotalWeightsByDate] = useState({});
  const [
    scenarioEstimationEventPerDate,
    setScenarioEstimationEventPerDate,
  ] = useState({});
  const metadataSlice = useSelector((state) => state.metadata);
  const textTitle = (phraseOne, phraseTwo, phraseThree, phraseFour) => (
    <div className={classes.tooltipContainer}>
      <div>{phraseOne}</div>
      <div>{phraseTwo}</div>
      <div>{phraseThree}</div>
      <div>{phraseFour}</div>
    </div>
  );

  useEffect(() => {
    setCalendarDays(values);
  }, [values]);

  const xLabels = _.uniq(
    _.map([...scenarioEstimationsDaily.data], (el) => {
      return moment(el.date).format("MMM'YY'DD");
    })
  );

  const scenarioEstimationDailyGroupedByDate = _.groupBy(
    scenarioEstimationsDaily.data,
    "date"
  );

  useEffect(() => {
    const totalWeightsByDateAux = {};
    const scenarioEstimationEventPerDateAux = {};
    _.forEach(
      scenarioEstimationDailyGroupedByDate,
      (groupedScenarioEstimation, key) => {
        totalWeightsByDateAux[key] =
          _.sumBy(groupedScenarioEstimation, (estimation) => {
            return estimation.units * estimation.daily_weight;
          }) /
          _.sumBy(groupedScenarioEstimation, (estimation) => {
            return estimation.units;
          });
        const eventTypeNotNull = _.find(
          groupedScenarioEstimation,
          (estimation) => {
            return estimation.event_id !== null;
          }
        );
        scenarioEstimationEventPerDateAux[key] =
          eventTypeNotNull !== undefined
            ? _.find(deltaEventsCatalog, { id: eventTypeNotNull.event_id })
            : { key: null, label: "TPR" };
      }
    );
    setTotalWeightsByDate(totalWeightsByDateAux);
    setScenarioEstimationEventPerDate(scenarioEstimationEventPerDateAux);
  }, [scenarioEstimationsDaily.data]);

  const getBackgroundBarsColorsArray = () => {
    const daysSelecteds = _.map(values, (value) => {
      return value.getDate ? value.getDate() : value.day;
    });
    return _.map(scenarioEstimationDailyGroupedByDate, (estimation) => {
      if (
        _.includes(daysSelecteds, Number(estimation[0].date.substring(8, 10)))
      ) {
        return "#E86861";
      }
      return "#EEEEEE";
    });
  };

  const priceUnit = metadataSlice.all.margin[0].unit;

  const borderColorSkip = [];
  const borderBarColorOption = [];
  _.forEach(scenarioEstimationEventPerDate, (value) => {
    if (value.key !== null) {
      borderBarColorOption.push("#999999");
      borderColorSkip.push(1.5);
    } else {
      borderBarColorOption.push("white");
      borderColorSkip.push(0);
    }
  });

  const data = {
    labels: xLabels,
    datasets: [
      {
        label: "Daily Weight",
        yAxisID: "daily-weight",
        type: "line",
        fill: false,
        borderColor: "#631C03",
        hoverBorderColor: "#631C03",
        hoverBorderWidth: 3,
        pointBordercolor: "#631C03",
        pointBackgroundColor: "#ffffff",
        backgroundColor: "#EEEEEE",
        pointHoverBackgroundColor: "#ffffff",
        pointHoverRadius: 6,
        unit: "%",
        data: _.map(
          _.groupBy(scenarioEstimationsDaily.data, "date"),
          (estimationGrouped, key) => {
            return {
              x: moment(key).format("DD MMMM'YY"),
              y: _.round(totalWeightsByDate[key] * 100, 1),
            };
          }
        ),
      },
      {
        label: "Price Out",
        yAxisID: "price-out",
        type: "bar",
        borderColor: borderBarColorOption,
        pointBordercolor: "#EEEEEE",
        borderWidth: borderColorSkip,
        pointBackgroundColor: "#ffffff",
        unit: priceUnit,
        backgroundColor: getBackgroundBarsColorsArray(),
        data: _.map(
          _.groupBy(scenarioEstimationsDaily.data, "date"),
          (estimationGrouped, key) => {
            return {
              x: moment(key).format("DD MMMM'YY"),
              y: _.round(
                _.sumBy(estimationGrouped, (estimation) => {
                  return estimation.price * estimation.units;
                }) / _.sumBy(estimationGrouped, "units"),
                metadataSlice["custom-projection"].price[0].decimals
              ),
            };
          }
        ),
      },
    ],
  };

  const StyledButton = withStyles(() => ({
    root: {
      minWidth: "0px",
      "&:hover": {
        backgroundColor: "#FAFAFA",
      },
    },
  }))(Button);

  const handleResetSelectedDays = () => {
    setValues([]);
    setIsSelectedDays(false);
  };

  const handleAplySelectedDays = () => {
    if (values?.length > 0) {
      setIsSelectedDays(true);
      // First we get just the days for the values of the calendar selected by the user
      const daysSelected = _.map(values, (date) => {
        return date.format("YYYY-MM-DD");
      });
      // Then we will filter out the values for the scenario estimations daily which have not those days includes
      const filteredEstimations = _.filter(
        scenarioEstimationsDaily.data,
        (estimation) => {
          return daysSelected.includes(estimation.date);
        }
      );

      const sumFilteredWeight = _.reduce(
        _.pickBy(totalWeightsByDate, (value, key) => {
          return daysSelected.includes(key);
        }),
        (accum, value) => {
          return accum + value;
        }
      );
      const datesFilteredEstimations = _.map(
        _.uniqBy(filteredEstimations, "date"),
        (estimation) => {
          return estimation.date;
        }
      );

      const sortDaysSelected = _.sortBy(daysSelected, (date) =>
        moment(date, "YYYY-MM-DD")
      );

      if (_.isEqual(datesFilteredEstimations, sortDaysSelected)) {
        setIsSelectedSameDays(true);
      } else {
        setIsSelectedSameDays(false);
      }
      setDailySelectedEstimations(filteredEstimations);
      setDailyTotalWeight(sumFilteredWeight);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.containerCalendar}>
        <Calendar
          className={classes.customCalendar}
          inputClass={classes.customCalendarInput}
          multiple
          value={values}
          onChange={setValues}
          hideMonth
          hideYear
          buttons={false}
          shadow={false}
          currentDate={
            new DateObject(
              scenariosSlice.selectedScenario.scenario.cycle.initial_date
            )
          }
          // mapDays={({ selectedDate }) => {
          //   const props = {}

          //   props.style = {
          //   }

          //   if (selectedDate) props.style.color = "green"
          //   else props.style = {
          //   }

          //   return props
          // }}
          // style={{
          //   border:"0px solid #cfd8e2",
          //   padding:"0px",
          // }}
        />
      </div>
      <div className={classes.containerIcons}>
        <div className={classes.resetIcon}>
          <StyledTooltip title={textTitle("Clear selection")} placement="right">
            <StyledButton
              disableRipple
              onClick={() => handleResetSelectedDays()}
            >
              <FiDelete className={classes.iconReset} />
            </StyledButton>
          </StyledTooltip>
        </div>
        <div className={classes.enterIcon}>
          <StyledTooltip title={textTitle("Apply selection")} placement="right">
            <StyledButton
              disableRipple
              onClick={() => handleAplySelectedDays()}
            >
              <EnterIcon className={classes.icon} />
            </StyledButton>
          </StyledTooltip>
        </div>
      </div>
      <div className={classes.expansionDetailsContainer}>
        <DailyPromotionsWeigthChartComponent
          data={data}
          scenarioEstimationEventPerDate={scenarioEstimationEventPerDate}
        />
      </div>
      <div className={classes.explicabilityContainer}>
        <ExplicabilityComponent
          tooltipText={textTitle(
            "Choose the days with the",
            "highest weight for more",
            "effective promotions"
          )}
        />
      </div>
    </div>
  );
}

export default DailyPromotionsComponent;
